const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ Only prepend base URL for login-related endpoints
const withBase = (endpoint) => `${API_BASE_URL}${endpoint}`;

const API_ENDPOINTS = {
  // ✅ Auth
  LOGINUSER: withBase("/user/login"),
  LOGINADMIN: withBase("/admin/login"),
  REGISTERUSER: withBase(process.env.REACT_APP_REGISTER_ENDPOINT),

  // ✅ Users
  GET_ALL_USERS: withBase(process.env.REACT_APP_GET_ALL_USERS_ENDPOINT),
  GET_USER_PROFILE: withBase(process.env.REACT_APP_GET_USER_PROFILE_ENDPOINT),

  // ✅ Addresses
  ADD_USER_ADDRESS: withBase(process.env.REACT_APP_ADD_USER_ADDRESS_ENDPOINT),
  GET_USER_ADDRESSES: withBase(process.env.REACT_APP_GET_USER_ADDRESSES_ENDPOINT),

  // ✅ Categories
  ADD_CATEGORY: process.env.REACT_APP_ADD_CATEGORY_ENDPOINT,
  GET_ALL_CATEGORIES: process.env.REACT_APP_GET_ALL_CATEGORIES_ENDPOINT,
 
  // ✅ Banners
  ADD_BANNER: process.env.REACT_APP_ADD_BANNER_ENDPOINT,
  GET_ALL_BANNERS: process.env.REACT_APP_GET_ALL_BANNERS_ENDPOINT,
  UPDATE_BANNER_STATUS: process.env.REACT_APP_UPDATE_BANNER_STATUS_ENDPOINT,

  // ✅ Products
  ADD_PRODUCT: process.env.REACT_APP_ADD_PRODUCT_ENDPOINT,
  GET_ALL_PRODUCTS: process.env.REACT_APP_GET_ALL_PRODUCTS_ENDPOINT,
  UPDATE_PRODUCT_STATUS: process.env.REACT_APP_UPDATE_PRODUCT_STATUS_ENDPOINT,
  UPDATE_PRODUCT_IMAGE: process.env.REACT_APP_UPDATE_PRODUCT_IMAGE_ENDPOINT,
  GET_SINGLE_PRODUCT: (id) => withBase(process.env.REACT_APP_GET_SINGLE_PRODUCT_ENDPOINT.replace(':id', id)),
  UPDATE_PRODUCT: (id) =>
    withBase(process.env.REACT_APP_UPDATE_PRODUCT_ENDPOINT.replace(':id', id)),
  // ✅ Blogs
  ADD_BLOG: process.env.REACT_APP_ADD_BLOG_ENDPOINT,
  GET_ALL_BLOGS: process.env.REACT_APP_GET_ALL_BLOGS_ENDPOINT,

  // ✅ Offers
  ADD_OFFER: process.env.REACT_APP_ADD_OFFER_ENDPOINT,
  GET_ALL_OFFERS: process.env.REACT_APP_GET_ALL_OFFERS_ENDPOINT,

  // ✅ Cart
  ADD_TO_CART: withBase(process.env.REACT_APP_ADD_TO_CART_ENDPOINT),
  GET_CART: withBase(process.env.REACT_APP_GET_CART_ENDPOINT),
  INCREMENT_CART_ITEM: withBase(process.env.REACT_APP_INCREMENT_CART_ITEM_ENDPOINT),
  DECREMENT_CART_ITEM: withBase(process.env.REACT_APP_DECREMENT_CART_ITEM_ENDPOINT),
  REMOVE_CART_ITEM: withBase(process.env.REACT_APP_REMOVE_CART_ITEM_ENDPOINT),
  // CLEAR_CART: withBase(process.env.REACT_APP_CLEAR_CART_ENDPOINT),



  SUBSCRIBE_EMAIL: withBase(process.env.REACT_APP_SUBSCRIBE_EMAIL_ENDPOINT),
  GET_ALL_SUBSCRIBERS: withBase(process.env.REACT_APP_GET_ALL_SUBSCRIBERS_ENDPOINT),

};

export { API_BASE_URL, API_ENDPOINTS };
           